// PrivateShowTicketShop.js
import { connect } from 'react-redux';

import PrivateShowTicketShop from '../component/PrivateShowTicketShop.jsx';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getGoalData from '../selector/getGoalData.js';
import getGiftData from '../selector/getGiftData.js';
import getPrivateShowTicketAmount from '../selector/getPrivateShowTicketAmount.js';
import getStreamTokenDecodedData from '../selector/getStreamTokenDecodedData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import getListData from '../selector/getListData.js';
import getIsPrivateShowUnlocked from '../selector/getIsPrivateShowUnlocked.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getPrivateShowProductId from '../selector/getPrivateShowProductId.js';

import sendLiveStreamGift from '../action/sendLiveStreamGift.js';
import updateOperationLivestream from '../action/updateOperationLivestream.js';
import login from '../action/login.js';
import addvalue from '../action/addvalue.js';

import {
  privateShowGiftType,
  privateShowStatus as privateShowStatusConstant,
} from '../resource/liveStreamConstants.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { NEED_AUTH_HANDLER } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const fundingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'fundingId'
  );
  const performingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'performingId'
  );
  const giftId = getPrivateShowProductId(
    state,
    streamId,
    fundingId,
    performingId
  );
  const mvpUserId = getListData(
    state,
    ['goal', fundingId, 'breakdown'],
    'itemIds'
  )?.[0];
  const meId = getMeData(state, 'id');
  const isAuthed = !!meId;
  const selectedGiftType = getOperationData(
    state,
    ['liveStream'],
    'selectedGiftType'
  );
  const title = getGoalData(state, [fundingId, 'levels', 0], 'title');
  const giftSendingStatus = getOperationData(
    state,
    ['liveStream', 'gift'],
    'giftSendingStatus'
  );
  const privateShowStatus = getPrivateShowStatus(state, streamId);
  const preset = getLiveStreamData(state, [streamId], 'preset');
  const streamTokenDecodedData = getStreamTokenDecodedData(state, streamId);
  const giftPrice = getGiftData(state, giftId, 'price');
  const moreCount = +getPrivateShowTicketAmount(
    state,
    streamId,
    fundingId,
    mvpUserId,
    meId,
    privateShowGiftType.MORE
  );
  const mvpCount = getPrivateShowTicketAmount(
    state,
    streamId,
    fundingId,
    mvpUserId,
    meId,
    privateShowGiftType.MVP
  );
  const performDuration = [
    privateShowStatusConstant.PERFORMING,
    privateShowStatusConstant.PREPARING,
  ].includes(privateShowStatus)
    ? getGoalData(state, [performingId, 'levels', 0], 'target')
    : getGoalData(state, [fundingId, 'context'], 'perform_duration');
  const isPrivateShowUnlocked = getIsPrivateShowUnlocked(
    state,
    streamId,
    fundingId,
    meId
  );
  const isPresenceGoalSubscribed = getOperationData(
    state,
    ['pusher', 'channels', `presence-enc-goal@${fundingId}.${meId}`],
    'subscribed'
  );
  const isPresenceStreamViewerSubscribed = getOperationData(
    state,
    [
      'pusher',
      'channels',
      `presence-enc-stream-viewer@${streamId}.${preset}.${meId}`,
    ],
    'subscribed'
  );
  const isFetchingDrmLicense = getNetworkingData(
    state,
    ['drm', 'live', streamId],
    'isFetching'
  );
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const isFetchingStreamToken = getNetworkingData(
    state,
    ['fetch', 'streamToken', sessionId],
    'isFetching'
  );
  const playerStatus = getLiveStreamData(state, [streamId], 'playerStatus');
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  return {
    fundingId,
    giftId,
    selectedGiftType,
    title,
    privateShowStatus,
    playerStatus,
    giftSendingStatus,
    drmTestStatus: getOperationData(state, ['drm'], 'testStatus'),
    moreCount,
    mvpCount,
    performDuration,
    giftPrice,
    isPrivateShowUnlocked,
    isPresenceGoalSubscribed,
    isPresenceStreamViewerSubscribed,
    isFetchingDrmLicense,
    isFetchingStreamToken,
    streamTokenDecodedData,
    streamStatus,
    isAuthed,
    needAuthHandler: getRemoteConfigData(state, NEED_AUTH_HANDLER),
    isSendGiftFetched: getNetworkingData(
      state,
      ['liveStream', streamId, 'gift', giftId],
      'isFetched'
    ),
    sendGiftFetchError: getNetworkingData(
      state,
      ['liveStream', streamId, 'gift', giftId],
      'error'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendLiveStreamGift: data => dispatch(sendLiveStreamGift(data)),
    updateOperationLivestream: ({ selectedGiftType }) =>
      dispatch(updateOperationLivestream({ selectedGiftType })),
    login: () => dispatch(login()),
    addvalue: () => dispatch(addvalue({ via: 'gift' })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateShowTicketShop);
